<template>
  <div>
    <div v-if="!$template.disabled_campaign_title" class="title campaign-title !my-1 lg:!my-4 text-normal"
      v-html="tagText($template.campaign_title)"></div>
    <div v-if="$template">
      <HeaderEntry />

      <Bandit v-if="$template.campaign_template_mechanic_id === 2" @endGame="isGameFinish = true"
        :code="code1.value.toString()" :alreadyPlay="false" :isFirst="true" />

      <ScratchGame v-if="$template.campaign_template_mechanic_id === 3" @endGame="isGameFinish = true"
        :code="code1.value.toString()" />

      <MemoryGame v-if="$template.campaign_template_mechanic_id === 4" @endGame="isGameFinish = true"
        :code="code1.value.toString()" />

      <WheelGame v-if="$template.campaign_template_mechanic_id === 5" @winner="onWheelWinner" @loser="onWheelLoser"
        @emailSubmitted="onWheelEmailSubmitted" :code="code1.value.toString()" />

      <div v-if="!$template.disabled_campaign_text && $template.campaign_template_mechanic_id === 2 && isGameFinish"
        class="text-normal" v-html="tagText($template.campaign_text)"></div>

      <div
        v-if="!$template.disabled_campaign_text && ($template.campaign_template_mechanic_id === 3 || $template.campaign_template_mechanic_id === 4 || $template.campaign_template_mechanic_id === 5) && isGameFinish"
        class="text-normal" v-html="tagText($template.campaign_text)"></div>

      <!-- Formulaire classique : affiché pour mécaniques 1-4 après jeu, ou pour wheel si perdant -->
      <Form v-if="showClassicForm" class="bg-white my-4 p-4" @submit="onSubmit">
        <div class="w-full m-auto">
          <p class="text-center text-sm">
            Vos données peuvent être utilisées pour vous adresser des offres commerciales par voie postale.
          </p>
          <p class="text-center mb-3 text-sm">
            Jeu réservé aux personnes habitant en France métropolitaine.
          </p>

          <div class="div-form">
            <InputText v-model="form.email" :required="true" label="Email" name="email" type="email"
              rules="required|email|max:50" :max="50" :errors="errors" :disabled="wheelLoser" />
            <InputSelect v-model="form.gender_id" :options="$store.genders" :required="true" label="Civilité"
              name="gender_id" rules="required" :errors="errors" />
          </div>

          <div class="div-form">
            <InputText v-model="form.last_name" :required="true" label="Nom" name="last_name" rules="required|max:21"
              :max="21" :errors="errors" />
            <InputText v-model="form.first_name" :required="true" label="Prénom" name="first_name"
              rules="required|max:16" :max="16" :errors="errors" />
          </div>

          <div class="div-form">
            <InputText v-model="form.address1" :required="true" label="Adresse" name="address1" rules="required|max:32"
              :max="32" :errors="errors" />
            <InputText v-model="form.address2" label="Complément d'adresse (optionnel)" name="address2" rules="max:32"
              :max="32" placeholder="Résidence, bâtiment, n° d'appartement, etc." :errors="errors" />
          </div>

          <div class="div-form">
            <InputText v-model="form.postal_code" :required="true" label="Code postal" name="postal_code"
              rules="required|max:5|min:5" :max="5" :errors="errors" />
            <InputSelect v-model="form.town" :options="towns" :required="true" label="Ville" name="town"
              rules="required|max:255" :errors="errors" />
          </div>

          <div class="div-form">
            <InputText v-model="form.landline_phone" :required="true" label="Téléphone" name="landline_phone"
              rules="required|max:13" :max="13" :errors="errors" @keydown.space.prevent />
            <InputText v-model="form.mobile_phone" label="Mobile" name="mobile_phone" rules="max:13" :max="13"
              :errors="errors" @keydown.space.prevent />
          </div>

          <div class="div-form">
            <InputText v-model="form.birth_at" :required="true" label="Date de naissance" name="birth_at" type="date"
              rules="required" :errors="errors" />
            <div class="lg:w-1/2 text-right lg:mt-10 mt-4 text-grey">
              <span class="text-red font-bold">*</span> champs obligatoires
            </div>
          </div>

          <div class="mt-4">
            J'accepte de recevoir les offres et jeux de vos différentes enseignes :
          </div>

          <div class="div-form flex flex-col ml-6">
            <Field v-slot="{ field }" :name="'optin_email'" type="checkbox" :value="true" :rules="''">
              <label>
                <input :id="'optin_email'" type="checkbox" :name="'optin_email'" v-bind="field" :value="true" />
                Par email
              </label>
            </Field>
            <ErrorMessage class="errorForm" :name="'optin_email'" />
          </div>

          <div class="div-form flex flex-col ml-6">
            <Field v-slot="{ field }" :name="'optin_sms'" type="checkbox" :value="true" :rules="''">
              <label>
                <input :id="'optin_sms'" type="checkbox" :name="'optin_sms'" v-bind="field" :value="true" />
                Par sms et automates d'appel
              </label>
            </Field>
            <ErrorMessage class="errorForm" :name="'optin_sms'" />
          </div>

          <div class="div-form flex flex-col">
            <Field v-slot="{ field }" :name="'optin_partners'" type="checkbox" :value="true" :rules="''">
              <label>
                <input :id="'optin_partners'" type="checkbox" :name="'optin_partners'" v-bind="field" :value="true" />
                J'accepte de recevoir les offres de vos partenaires par email
              </label>
            </Field>
            <ErrorMessage class="errorForm" :name="'optin_partners'" />
          </div>

          <div v-if="this.$store.optinVariant === 'optin'" class="div-form flex flex-col">
            <Field v-slot="{ field }" :name="'optin_rules'" type="checkbox" :value="true" :rules="'required'">
              <label>
                <input :id="'optin_rules'" type="checkbox" :name="'optin_rules'" v-bind="field" :value="true" />
                <span v-if="code2"> En validant mon numéro de participation ci-dessous</span>, je déclare avoir lu et
                accepté
                <span class="link" @click="
                  openModal(
                    'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                    $template.rules,
                    $template.rules_picture
                  )
                  ">le règlement de jeu</span>
                <span class="text-red font-bold"> * </span>
              </label>
            </Field>
            <ErrorMessage class="errorForm" :name="'optin_rules'" />
          </div>

          <div class="w-[80%] lg:w-full mt-4 pb-6 flex justify-center text-base lg:text-xl mx-auto">
            <button v-if="this.$store.optinVariant === 'optin'" class="button-validation lg:!p-3" v-html="tagText($template.campaign_button)">
            </button>
            <button v-else class="button-validation lg:!p-3 flex flex-col items-center justify-center gap-1">
              <span v-html="tagText($template.campaign_button)"></span>
              
              <div class="flex flex-wrap justify-center gap-1 mt-3 text-base">
                  <span class="font-normal">et déclare avoir lu le</span>
                  <span class="cursor-pointer underline font-normal" @click.prevent="openModal(
                      'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                      $template.rules,
                      $template.rules_picture
                  )">règlement de jeu</span>
              </div>
          </button>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import HeaderEntry from '../common/components/HeaderEntry.vue'
import Bandit from '../common/components/Bandit.vue'
import ScratchGame from '../common/components/ScratchGame.vue'
import MemoryGame from '../common/components/MemoryGame.vue'
import WheelGame from '../common/components/WheelGame.vue'
import InputText from '../common/components/Inputs/InputText.vue'
import InputSelect from '../common/components/Inputs/InputSelect.vue'
import { sendAgencyTracking } from '../services/agencyTracking'
import { ErrorMessage, Field, Form } from 'vee-validate'
import moment from 'moment'
import { consoleLoggingIntegration } from '@sentry/vue'

export default {
  name: 'EntryAView',
  components: {
    HeaderEntry,
    Bandit,
    ScratchGame,
    MemoryGame,
    WheelGame,
    InputText,
    InputSelect,
    ErrorMessage,
    Form,
    Field
  },
  emits: ['openModal', 'openNotification'],
  data: () => ({
    errors: [],
    form: {},
    towns: [],
    isGameFinish: false,
    isLoading: false,
    wheelLoser: false, // Si perdant à la roue, afficher le formulaire classique
    wheelEmail: '', // Email saisi pour la roue
  }),
  computed: {
    code1() {
      return this.$store.participationCode1 ?? null
    },
    code2() {
      return this.$store.participationCode2 ?? null
    },
    // Condition pour afficher le formulaire classique
    showClassicForm() {
      const mechanicId = this.$template.campaign_template_mechanic_id

      // Pour wheel (5): seulement si perdant
      if (mechanicId === 5) {
        return this.wheelLoser
      }

      // Pour les autres mécaniques (2, 3, 4): après le jeu
      if (mechanicId === 2 || mechanicId === 3 || mechanicId === 4) {
        return this.isGameFinish
      }

      // Pour mécanique 1 (sans jeu): toujours afficher
      return true
    },
    getGenderForm() {
      if (this.$store.genderGet && this.$store.genderGet === 'Mr' || this.$store.genderGet === 'M.' || this.$store.genderGet === 'Mme') {
        return this.$store.genderGet === 'Mr' || this.$store.genderGet === 'M.' ? 2 : 1
      }
      return this.$user?.gender_id ?? ''
    },
    getEmailForm() {
      if (this.$store.emailGet) {
        return this.$store.emailGet
      }
      return this.$user?.email.trim() ?? ''
    },
    getLastNameForm() {
      if (this.$store.lastnameGet) {
        return this.$store.lastnameGet
      }
      return this.$user?.last_name ?? ''
    },
    getFirstNameForm() {
      if (this.$store.firstnameGet) {
        return this.$store.firstnameGet
      }
      return this.$user?.first_name ?? ''
    },
    getZipCodeForm() {
      if (this.$store.zipcodeGet) {
        return this.$store.zipcodeGet
      }
      return this.$user?.address?.postal_code ?? ''
    },
    getPhoneForm() {
      if (this.$store.phoneGet) {
        return this.$store.phoneGet.replace(/\s+/g, '')
      }
      return this.$user?.address?.landline_phone ? this.$user.address.landline_phone.replace(/\s+/g, '') : ''
    },
    getBirthDateForm() {
      var dateRegexFr = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/; // JJ/MM/AAAA
      var dateRegexIso = /^\d{4}-\d{2}-\d{2}$/; // AAAA-MM-JJ
      if (this.$store.dateofbirthGet) {
        if (dateRegexFr.test(this.$store.dateofbirthGet)) {
          return moment(this.$store.dateofbirthGet, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        if (dateRegexIso.test(this.$store.dateofbirthGet)) {
          return moment(this.$store.dateofbirthGet, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
      }
      return this.$user?.birth_at
        ? moment(this.$user.birth_at).format('YYYY-MM-DD')
        : '';
    },
  },
  created() {
    if (this.$user && this.$template.mandatory_purchase) {
      this.$router.replace({ name: 'product' })
    }
    function titleCase(string) {
      return;
    }

    this.form = {
      email: this.getEmailForm,
      gender_id: this.getGenderForm,
      last_name: this.getLastNameForm,
      first_name: this.getFirstNameForm,
      town: this.$user?.address?.town ? (this.$user?.address?.town[0].toUpperCase() + this.$user?.address?.town.slice(1).toLowerCase()) : '',
      postal_code: this.getZipCodeForm,
      address1: this.$user?.address?.address1 ?? '',
      address2: this.$user?.address?.address2 ?? '',
      // landline_phone: this.$user?.address?.landline_phone ? this.$user.address.landline_phone.replace(/\s+/g, '') :  '',
      // mobile_phone: this.getPhoneForm,
      mobile_phone: this.$user?.address?.mobile_phone ? this.$user.address.mobile_phone.replace(/\s+/g, '') : '',
      landline_phone: this.getPhoneForm,
      additionnal_info: this.$user?.address?.additionnal_info ?? '',
      birth_at: this.getBirthDateForm
    }
  },
  methods: {
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    },
    async onSubmit(values) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      if (values.optin_email === undefined) {
        values.optin_email = false
      }
      if (values.optin_sms === undefined) {
        values.optin_sms = false
      }
      if (values.optin_partners === undefined) {
        values.optin_partners = false
      }
      values.optin_rules = true
      values.optin_variant = this.$store.optinVariant

      try {
        if (this.$user) {
          const res = await this.$api.validateParticipation(
            this.$store.participation.id,
            values
          )
          if (res.status === 422) {
            this.errors = res.data.errors
          } else {
            if (res.data.user.is_blocked_user) {
              this.$store.setMessageError('Votre compte est désactivé')
              this.$router.push({ name: 'error' })
              return
            }
            this.$store.setParticipation(res.data.participation)
            this.$store.setUser(res.data.user)

            this.$router.replace({ name: 'product' })
          }
        } else {
          let datas = values
          datas.campaign_id = this.$campaign.id
          datas.landing_id = this.$store.idLanding
          datas.code_1 = this.$store.participationCode1.id
          if (this.$store.participationCode2) {
            datas.code_2 = this.$store.participationCode2.id
          }

          datas = { ...this.$store.utms, ...datas }

          const res = await this.$api.createUser(datas)

          if (res.status === 422) {
            if (res.data.errors) {
              this.errors = res.data.errors
            } else {
              this.errors.email = [res.data.message]
            }
          } else {
            if (res.data.user.is_blocked_user) {
              this.$store.setMessageError('Votre compte est désactivé')
              this.$router.push({ name: 'error' })
              return
            }

            await sendAgencyTracking({
              isTracking: res.data?.is_tracking,
              utms: this.$store.utms
            })

            this.$store.setUser(res.data.user)
            this.$store.setParticipation(res.data.participation)
            //subscribe 
            if (!window.location.href.includes('localhost') && !window.location.href.includes('digiworks')) {
              this.$gtm.trackEvent({
                event: 'subscribe',
                campaignid: this.$campaign.code
              });
            }

            this.$router.replace({ name: 'product' })
          }
        }
      } catch (e) {
        console.log(e)
      }
      this.isLoading = false
    },

    // Méthodes pour la roue de la fortune (mécanique 5)
    onWheelEmailSubmitted(email) {
      this.wheelEmail = email
      // Pré-remplir le formulaire avec l'email au cas où il perd
      this.form.email = email
    },

    onWheelWinner() {
      this.wheelLoser = false
    },

    onWheelLoser() {
      this.wheelLoser = true
    }
  },
  watch: {
    // whenever question changes, this function will run
    async 'form.postal_code'(newValue) {
      if (newValue.length == 5) {
        const res = await this.$api.getTowns(newValue)
        if (res.data.length > 0) {
          this.towns = res.data
          let userTown = this.$user?.address.town ? this.towns.find(town => this.$user.address.town.toUpperCase() == town.nom.toUpperCase()) : null
          if (userTown) {
            this.form.town = userTown.nom
          }

          this.errors = {
            postal_code: null
          }
        } else {
          this.errors = {
            postal_code:
              { 0: 'Le code postal n\'est pas valide.' }
          }
        }
      }
      else {
        this.errors = {
          postal_code: null
        }
      }
    }
  },
}
</script>

<style scoped>
.campaign-title {
  background-color: v-bind("$template ? $template.campaign_title_background_color : ''"
    );
}

.button-validation {
  background-color: v-bind("$template ? $template.campaign_button_background_color : ''"
    );
  color: v-bind("$template ? $template.campaign_button_text_color : ''");
}

.campaign-container {
  background-color: v-bind("$template && !$template.disabled_campaign_text ? $template.campaign_text_background_color : ''"
    );
}

.campaign-container {
  @apply p-8;
}

.div-form {
  @apply lg:flex w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
